import { useState, useEffect, useCallback } from "react";
import Pacmanloader from "../Pacmanloader/Pacmanloader";
import Select from "react-select";
import ResultTable from "../Results/ResultTable";
import StatusBadge from "../Badges/StatusBadge";
import { Row, Col, Button } from "reactstrap";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import CourseModulesResultsBar from "../Results/CourseModulesResultsBar";
import moment from "moment";
import { withRouter } from "react-router-dom";
import ClassResultQuestionOverview from "../Results/ClassResultQuestionOverview";
import { getWinOptions } from "../../Utilities/moduleHelper";
import { LW_COURSE_API_URL } from "../../constants/api.constants";
import StudentResultQuestionOverview from "../Results/StudentResultQuestionOverview";
import "moment/locale/sv";

function ClassResultOverview({ classData, classCoursesData, intl }) {
  const [resultTableData, setResultTableData] = useState(null);
  const [primaryModulesData, setPrimaryModulesData] = useState({});
  const [secondaryModulesData, setSecondaryModulesData] = useState({});
  const [courseId, setCourseId] = useState(null);
  const [moduleId, setModuleId] = useState(null);
  const [courseName, setCourseName] = useState(null);
  const [moduleName, setModuleName] = useState(null);
  const [showClassResult, setShowClassResult] = useState(false);
  const [classResultIsOpen, setClassResultIsOpen] = useState(false);
  const [showStudentResult, setShowStudentResult] = useState(false);
  const [studentForScormResults, setStudentForScormResults] = useState({});
  const [studentBestResultIsOpen, setStudentBestResultIsOpen] = useState(false);
  const [studentLatestResultIsOpen, setStudentLatestResultIsOpen] =
    useState(false);
  const [isGy25FinalExam, setIsGy25FinalExam] = useState(false);
  const [finalExamVariantId, setFinalExamVariantId] = useState(null);
  moment.locale("sv");

  const toggle = () => setClassResultIsOpen(!classResultIsOpen);
  const toggleLatestStudentResult = () =>
    setStudentLatestResultIsOpen(!studentLatestResultIsOpen);

  const toggleBestStudentResult = () =>
    setStudentBestResultIsOpen(!studentBestResultIsOpen);

  const viewAt2Result = (studentEmail, currentCourseId, currentModuleId) => {
    var winOptions = getWinOptions;
    window.open(
      `${LW_COURSE_API_URL}/Home/ViewModuleResult?` +
        "email=" +
        encodeURIComponent(studentEmail) +
        "&courseId=" +
        currentCourseId +
        "&moduleId=" +
        currentModuleId,
      "",
      winOptions
    );
  };

  const viewScormResultForClass = (
    courseId,
    moduleId,
    courseName,
    moduleName
  ) => {
    setShowClassResult(true);
    setShowStudentResult(false);
    setCourseId(courseId);
    setModuleId(moduleId);
    setCourseName(courseName);
    setModuleName(moduleName);
    setStudentBestResultIsOpen(false);
    setStudentLatestResultIsOpen(false);
    setClassResultIsOpen(true);
    window.scrollTo({
      top: 300,
      behavior: "smooth",
    });
  };

  const viewScormResultForStudent = (
    courseId,
    moduleId,
    courseName,
    moduleName,
    studentId,
    studentName
  ) => {
    setShowStudentResult(true);
    setShowClassResult(false);
    setCourseId(courseId);
    setModuleId(moduleId);
    setCourseName(courseName);
    setModuleName(moduleName);
    setStudentForScormResults({ name: studentName, id: studentId });
    setStudentBestResultIsOpen(true);
    setStudentLatestResultIsOpen(true);
    window.scrollTo({
      top: 300,
      behavior: "smooth",
    });
  };

  const viewGy25FinalExamResultForStudent = (
    courseId,
    moduleId,
    moduleName,
    courseName,
    variantId,
    studentName,
    studentId
  ) => {
    setShowStudentResult(true);
    setShowClassResult(false);
    setCourseId(courseId);
    setModuleId(moduleId);
    setCourseName(courseName);
    setModuleName(moduleName);
    setStudentForScormResults({ name: studentName, id: studentId });
    setStudentBestResultIsOpen(true);
    setStudentLatestResultIsOpen(true);
    setIsGy25FinalExam(true);
    setFinalExamVariantId(variantId);
    window.scrollTo({
      top: 300,
      behavior: "smooth",
    });
  };

  const viewGy25FinalExamResultForClass = (
    courseId,
    moduleId,
    moduleName,
    courseName,
    variantId
  ) => {
    setShowStudentResult(false);
    setShowClassResult(true);
    setCourseId(courseId);
    setModuleId(moduleId);
    setCourseName(courseName);
    setModuleName(moduleName);
    setStudentBestResultIsOpen(true);
    setStudentLatestResultIsOpen(true);
    setIsGy25FinalExam(true);
    setFinalExamVariantId(variantId);
    window.scrollTo({
      top: 300,
      behavior: "smooth",
    });
  };

  const sortStudentsByName = (tableData) => {
    const result = [];

    tableData.forEach((item) => {
      if (item.parentId === null) {
        result.push(item);

        const students = tableData
          .filter((student) => student.parentId === item.id)
          .sort((a, b) => a.name.localeCompare(b.name));

        result.push(...students);
      }
    });

    return result;
  };

  const setResultData = useCallback(
    (course) => {
      let tableData = [];
      let primaryChartData = {
        labels: [],
        datasets: [
          {
            label: intl.formatMessage({ id: "Done" }),
            value: "Done",
            data: [],
            backgroundColor: "#65C587",
          },
          {
            label: intl.formatMessage({ id: "InProgress" }),
            value: "InProgress",
            data: [],
            backgroundColor: "#FDC929",
          },
          {
            label: intl.formatMessage({ id: "NotStarted" }),
            value: "NotStarted",
            data: [],
            backgroundColor: "grey",
            border: "1px solid black",
          },
        ],
      };
      let secondaryChartData = {
        labels: [],
        datasets: [
          {
            label: intl.formatMessage({ id: "Done" }),
            value: "Done",
            data: [],
            backgroundColor: "#65C587",
          },
          {
            label: intl.formatMessage({ id: "InProgress" }),
            value: "InProgress",
            data: [],
            backgroundColor: "#FDC929",
          },
          {
            label: intl.formatMessage({ id: "NotStarted" }),
            value: "NotStarted",
            data: [],
            backgroundColor: "grey",
            border: "1px solid black",
          },
        ],
      };

      let currentCourse = classCoursesData.data.find((c) => c.id === course.id);
      let sortedModules = currentCourse.modules.sort((a, b) => {
        return a.sortOrder - b.sortOrder;
      });

      sortedModules.forEach((mod, i) => {
        if (mod.isGy25 && !mod.isFactModule && !mod.isFinalExam) return;

        const isGy25FactModule =
          mod.isGy25 && mod.isFactModule && !mod.isFinalExam;

        let coupledTestMod = null;

        if (isGy25FactModule) {
          coupledTestMod = sortedModules.find(
            (s) =>
              s.moduleCoupleId === mod.moduleCoupleId &&
              s.moduleId !== mod.moduleId &&
              s.isGy25 &&
              !s.isFactModule &&
              !s.isFinalExam
          );
        }

        let studentsWithResults = [];
        let notStarted = 0;
        let inProgress = 0;
        let done = 0;
        let module = {
          id: "m" + mod.moduleId,
          parentId: null,
          name: mod.name,
          showResult:
            mod.isGy25 && mod.isFinalExam ? (
              <></>
            ) : mod.moduleType !== 1 ? (
              <Button
                className="btn btn-outline-primary btn-sm"
                style={{ background: "transparent" }}
                onClick={() =>
                  viewScormResultForClass(
                    currentCourse.id,
                    coupledTestMod?.moduleId || mod.moduleId,
                    currentCourse.courseName,
                    mod.name
                  )
                }
              >
                <FormattedMessage id="ShowResult" />
              </Button>
            ) : null,
        };
        tableData.push(module);
        if (i < currentCourse.modules.length / 2) {
          primaryChartData.labels.push(mod.name);
        } else {
          secondaryChartData.labels.push(mod.name);
        }

        if (mod.isGy25 && mod.isFinalExam) {
          const availableVariants = [];
          mod.students.forEach((stud) => {
            stud.finalExamVariants.forEach((variant) => {
              if (
                !availableVariants.some(
                  (v) => v.variantId === variant.variantId
                )
              ) {
                availableVariants.push(variant);
              }
              var scorePercentage = 0;
              if (
                variant.score != null &&
                typeof variant.score === "number" &&
                variant.score > 0 &&
                variant.maxScore != null &&
                typeof variant.maxScore === "number" &&
                variant.maxScore > 0
              ) {
                scorePercentage = Math.round(
                  (variant.score / variant.maxScore) * 100
                );
              }
              const studentToAdd = {
                studentId: stud.studentId,
                id: "student" + stud.studentId,
                parentId: "variant" + variant.variantId,
                showResult: (
                  <Button
                    className="btn btn-outline-primary btn-sm"
                    style={{ background: "transparent" }}
                    onClick={() =>
                      viewGy25FinalExamResultForStudent(
                        currentCourse.id,
                        mod.moduleId,
                        mod.name,
                        currentCourse.courseName,
                        variant.variantId,
                        stud.name,
                        stud.studentId
                      )
                    }
                  >
                    <FormattedMessage id="ShowResult" />
                  </Button>
                ),
                name: stud.name,
                status: (
                  <StatusBadge status={variant.status} isGy25FinalExam={true} />
                ),
                statusCode: null,
                score:
                  variant.score != null
                    ? `${variant.score} (${scorePercentage}%)`
                    : null,
                nbrOfAttempts: variant.lastRun != null ? 1 : 0,
                activityPoints: null,
                lastRun: variant.lastRun
                  ? moment(variant.lastRun).format("lll")
                  : null,
                activityPointsPercentage: null,
              };
              tableData.push(studentToAdd);
            });

            switch (stud.finalExamStatus) {
              case "InProgress":
              case "Done":
                inProgress++;
                break;
              case "Completed":
                done++;
                break;
              case "NotStarted":
                notStarted++;
                break;
              default:
                break;
            }
          });
          const availableVariantsToAdd = [];
          availableVariants.forEach((variant) => {
            const variantToAdd = {
              id: "variant" + variant.variantId,
              parentId: "m" + mod.moduleId,
              showResult: (
                <Button
                  className="btn btn-outline-primary btn-sm"
                  style={{ background: "transparent" }}
                  onClick={() =>
                    viewGy25FinalExamResultForClass(
                      currentCourse.id,
                      mod.moduleId,
                      mod.name,
                      currentCourse.courseName,
                      variant.variantId
                    )
                  }
                >
                  <FormattedMessage id="ShowResult" />
                </Button>
              ),
              name: variant.name,
              status: null,
              statusCode: null,
              score: null,
              nbrOfAttempts: null,
              activityPoints: null,
              lastRun: null,
              activityPointsPercentage: null,
              lastRunForSort: variant.lastRun,
            };
            availableVariantsToAdd.push(variantToAdd);
          });
          tableData.push(
            ...availableVariantsToAdd.sort(
              (a, b) => new Date(b.lastRunForSort) - new Date(a.lastRunForSort)
            )
          );
        } else {
          mod.students.forEach((stud) => {
            studentsWithResults.push(stud.studentId);
            let studentToAdd = stud;

            const studentTestMod =
              coupledTestMod?.students?.find(
                (s) => s.studentId === studentToAdd.studentId
              ) || null;

            const getStatusBadge = () => {
              if (mod.isGy25 && mod.isFinalExam) {
                return (
                  <StatusBadge
                    status={studentToAdd.status}
                    isGy25FinalExam={true}
                  />
                );
              }

              return coupledTestMod ? (
                <>
                  <StatusBadge
                    status={studentToAdd?.status || "NotStarted"}
                    title={intl.formatMessage({ id: "StatusForFactModule" })}
                  />
                  <StatusBadge
                    status={studentTestMod?.status || "NotStarted"}
                    title={intl.formatMessage({ id: "StatusForTestModule" })}
                    isTestModule={true}
                  />
                </>
              ) : (
                <StatusBadge status={studentToAdd.status} />
              );
            };

            const getModuleScore = () => {
              const { score = 0, maxScore = 0 } =
                coupledTestMod && studentTestMod
                  ? studentTestMod
                  : studentToAdd;

              const percentage =
                coupledTestMod && studentTestMod
                  ? studentTestMod.scoreInPercent
                  : studentToAdd.scoreInPercent;

              return `${score}/${maxScore} (${percentage}%)`;
            };

            const getNbrOfAttempt = () => {
              if (studentTestMod && studentTestMod.nbrOfAttempts > 0) {
                return studentTestMod.nbrOfAttempts;
              }
              return studentToAdd.nbrOfAttempts ?? 0;
            };

            const getActivityPoints = () => {
              if (mod.isGy25 && mod.isFinalExam) return null;

              const points = studentToAdd.activityPoints ?? 0;
              const maxPoints = studentToAdd.maxActivityPoints ?? 0;

              const percentage =
                maxPoints > 0 ? Math.round((points / maxPoints) * 100) : 0;

              return `${points}/${maxPoints} (${percentage}%)`;
            };

            const getLastRun = () => {
              const factModLastRun = studentToAdd.lastRun
                ? moment(studentToAdd.lastRun)
                : null;
              const testModLastRun =
                coupledTestMod && studentTestMod?.lastRun
                  ? moment(studentTestMod.lastRun)
                  : null;

              if (!factModLastRun && !testModLastRun) return null;

              let lastRun = testModLastRun?.isAfter(factModLastRun)
                ? testModLastRun
                : factModLastRun;

              let title = "";

              if (isGy25FactModule) {
                title =
                  lastRun === factModLastRun
                    ? intl.formatMessage({ id: "LastRun_FactModule" })
                    : intl.formatMessage({ id: "LastRun_TestModule" });
              }

              return <span title={title}>{lastRun.format("lll")}</span>;
            };

            let student = {
              studentId: studentToAdd.studentId,
              id: "s" + studentToAdd.studentId + "mod" + mod.moduleId,
              parentId: "m" + mod.moduleId,
              showResult:
                mod.isGy25 && mod.isFinalExam ? (
                  <></>
                ) : mod.moduleType === 1 ? (
                  <Button
                    className="btn btn-outline-primary btn-sm"
                    style={{ background: "transparent" }}
                    onClick={() =>
                      viewAt2Result(stud.email, currentCourse.id, mod.moduleId)
                    }
                  >
                    <FormattedMessage id="ShowResult" />
                  </Button>
                ) : (
                  <Button
                    className="btn btn-outline-primary btn-sm"
                    style={{ background: "transparent" }}
                    onClick={() =>
                      viewScormResultForStudent(
                        currentCourse.id,
                        coupledTestMod?.moduleId || mod.moduleId,
                        currentCourse.name,
                        mod.name,
                        stud.studentId,
                        stud.name
                      )
                    }
                  >
                    <FormattedMessage id="ShowResult" />
                  </Button>
                ),
              name: studentToAdd.name,
              status: getStatusBadge(),
              statusCode:
                coupledTestMod != null && studentTestMod != null
                  ? studentTestMod.status
                  : studentToAdd.status,
              score: getModuleScore(),
              nbrOfAttempts: getNbrOfAttempt(),
              activityPoints: getActivityPoints(),
              lastRun: getLastRun(),
              scorePercent: studentToAdd.score
                ? Math.round((studentToAdd.score / studentToAdd.maxScore) * 100)
                : 0,
              activityPointsPercentage:
                mod.isGy25 && mod.isFinalExam
                  ? null
                  : studentToAdd.activityPoints
                  ? Math.round(
                      (studentToAdd.activityPoints /
                        studentToAdd.maxActivityPoints) *
                        100
                    )
                  : 0,
            };

            tableData.push(student);

            const studStatus = coupledTestMod
              ? studentTestMod?.status ?? "NotStarted"
              : stud.status;

            switch (studStatus) {
              case "InProgress":
                inProgress++;
                break;
              case "Done":
                done++;
                break;
              default:
                break;
            }
          });
        }
        if (!(mod.isGy25 && mod.isFinalExam)) {
          notStarted = currentCourse.students.length - mod.students.length;
          let studentsNotStarted = [];
          currentCourse.students.forEach((stud) => {
            if (!studentsWithResults.includes(stud.studentId)) {
              studentsNotStarted.push(stud);
            }
          });
          studentsNotStarted.forEach((stud) => {
            let studentNotStarted = {
              id: "s" + stud.studentId,
              parentId: "m" + mod.moduleId,
              name: stud.name,
              status: coupledTestMod ? (
                <>
                  <StatusBadge
                    status={"NotStarted"}
                    title={intl.formatMessage({ id: "StatusForFactModule" })}
                  />
                  <StatusBadge
                    status={"NotStarted"}
                    title={intl.formatMessage({ id: "StatusForTestModule" })}
                    isTestModule={true}
                  />
                </>
              ) : (
                <StatusBadge status={"NotStarted"} />
              ),
              score: 0,
              activityPoints: 0,
              nbrOfAttempts: 0,
            };
            tableData.push(studentNotStarted);
          });
        }
        if (i < currentCourse.modules.length / 2) {
          primaryChartData.datasets
            .find((element) => element.value === "InProgress")
            .data.push(inProgress);
          primaryChartData.datasets
            .find((element) => element.value === "NotStarted")
            .data.push(notStarted);
          primaryChartData.datasets
            .find((element) => element.value === "Done")
            .data.push(done);
        } else {
          secondaryChartData.datasets
            .find((element) => element.value === "InProgress")
            .data.push(inProgress);
          secondaryChartData.datasets
            .find((element) => element.value === "NotStarted")
            .data.push(notStarted);
          secondaryChartData.datasets
            .find((element) => element.value === "Done")
            .data.push(done);
        }
      });

      const sortedTableData = sortStudentsByName(tableData);

      setPrimaryModulesData(primaryChartData);
      setSecondaryModulesData(secondaryChartData);
      setResultTableData(sortedTableData);
    },

    [classCoursesData.data, intl]
  );

  useEffect(() => {
    if (!classCoursesData.isLoading) {
      setResultData(classCoursesData.data[0]);
    }
  }, [classCoursesData.isLoading, classCoursesData.data, setResultData]);

  if (classCoursesData.isLoading) {
    return <Pacmanloader />;
  }

  let columnExtensions = [
    { columnName: "name", width: 280 },
    { columnName: "showResult", width: 130 },
    { columnName: "status", width: 180 },
    { columnName: "score", width: 170 },
    { columnName: "nbrOfAttempts", width: 130 },
    { columnName: "activityPoints", width: 160 },
    { columnName: "lastRun", width: 200 },
  ];

  let columns = [
    { title: <FormattedMessage id="Name" />, name: "name" },
    { title: <FormattedMessage id="ShowResult" />, name: "showResult" },
    { title: <FormattedMessage id="Status" />, name: "status" },
    { title: <FormattedMessage id="ModuleTestScore" />, name: "score" },
    {
      title: <FormattedMessage id="NumberOfAttempts" />,
      name: "nbrOfAttempts",
    },
    { title: <FormattedMessage id="ActivityPoints" />, name: "activityPoints" },
    { title: <FormattedMessage id="LastRun" />, name: "lastRun" },
  ];

  const courses = [];
  classCoursesData.data.forEach((c) => {
    let course = { id: c.id, courseName: c.courseName };
    courses.push(course);
  });
  const firstCourse = classCoursesData.data[0];

  var studentIdArray = [];
  classData.students.forEach((student) => {
    studentIdArray.push(student.id);
  });

  const handleChangedCourse = (value) => {
    setShowStudentResult(false);
    setResultData(value);
  };

  return (
    <div>
      <Row>
        <Col lg={4} style={{ zIndex: "999" }}>
          <Select
            key={classData.id}
            defaultValue={{
              label: firstCourse.courseName,
              value: firstCourse.id,
            }}
            options={courses.map((option) => ({
              ...option,
              label: option.courseName,
              value: option.id,
            }))}
            onChange={(value) => {
              handleChangedCourse(value);
            }}
          />
        </Col>
      </Row>
      <div>
        <CourseModulesResultsBar
          primaryData={primaryModulesData}
          secondaryData={secondaryModulesData}
        />
      </div>
      {moduleId && courseId && showClassResult && (
        <ClassResultQuestionOverview
          classId={classData.id}
          students={classData.students}
          courseId={courseId}
          moduleId={moduleId}
          moduleName={moduleName}
          courseName={courseName}
          resultIsOpen={classResultIsOpen}
          toggle={toggle}
          isGy25FinalExam={isGy25FinalExam}
          variantId={finalExamVariantId}
        />
      )}
      {showStudentResult && (
        <StudentResultQuestionOverview
          studentId={studentForScormResults.id}
          courseId={courseId}
          moduleId={moduleId}
          moduleName={moduleName}
          courseName={studentForScormResults.name}
          bestResultIsOpen={studentBestResultIsOpen}
          toggleBest={toggleBestStudentResult}
          latestResultIsOpen={studentLatestResultIsOpen}
          toggleLatest={toggleLatestStudentResult}
          isGy25FinalExam={isGy25FinalExam}
          variantId={finalExamVariantId}
        />
      )}
      {resultTableData !== null ? (
        <ResultTable
          level="Class"
          tableData={resultTableData}
          columnExtensions={columnExtensions}
          columns={columns}
        />
      ) : (
        ""
      )}
    </div>
  );
}
ClassResultOverview.propTypes = {
  intl: intlShape.isRequired,
};

export default withRouter(injectIntl(ClassResultOverview));
